import { Module } from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import { IAdminState } from './types'

export const state = {} as IAdminState

const Admin: Module<IAdminState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default Admin
